import { SxProps, Theme } from "@mui/material";
import { HSV_BRAND_COLORS } from "../../../theme/common";

export const linkCardStyles: SxProps<Theme> = {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 1,
    transition: "0.2s ease",
    "&:hover": {
        transform: "translateY(-2px)",
    },
};

export const linkCardImageWrapper: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: HSV_BRAND_COLORS.blueLight,
    borderRadius: 0.5,
    p: 2,
    height: "100px",
    width: "100px",
};

export const linkCardImage: SxProps<Theme> = {
    width: "75px",
    height: "75px",
    objectFit: "contain",
};

export const linkCardTitle: SxProps<Theme> = {
    color: HSV_BRAND_COLORS.white,
    fontWeight: "400",
    textAlign: "center",
};
